<div class="row">
  <div class="col-12 col-lg-3 py-1">
    <app-multi-select-enum
      [enum]="AuthorTypeEnum"
      [formControl]="form.controls.type"
      translateKey="authorTypeEnum"
      [multi]="false"
    ></app-multi-select-enum>
  </div>

  <div class="col-12 col-lg-6 col-xl-7 py-1">
    @if (form.controls.type.value === 'team_member') {
      <app-multi-select-with-service
        [formControl]="form.controls.team_member_id"
        [service]="addableTeamMembersService"
        [reloadEmitter]="authorCreated"
        searchOnField="first_name"
        selectionMode="single_id"
      ></app-multi-select-with-service>
    } @else {
      <app-form-group
        [formControl]="form.controls.name"
      ></app-form-group>
    }
  </div>

  <div class="col-12 col-lg-3 col-xl-2 py-1 d-flex gap-2 align-items-start">
    <button class="btn btn-primary w-100" (click)="save()">{{ 'authenticated.administration.publications.edit.authors.create.save_btn' | translate }}</button>
  </div>
</div>
